module.exports = __webpack_public_path__ + "img/img_C3.12.15.c08304f4.png";